export default "__VITE_ASSET__imni8K6o__"